<template>
    <div data-test-id="accessory">
        <div :id="id" class="accessory-card" @click="onCardClick">
            <ob1-cards
                class="p-1"
                :with-composite-link="false"
                :is-selected="isAdded"
            >
                <div class="row">
                    <div class="accessory-card-promo-tag mt--1 float-start">
                        <ob1-tag
                            v-if="currentVersion.banner"
                            :label="currentVersion.banner"
                        />
                    </div>
                    <div class="accessory-card-picture px-0 col-12 d-flex align-items-center">
                        <img
                            v-if="currentVersion.pictures.length > 0"
                            :alt="currentVersion.pictures[0].alt"
                            :src="currentVersion.pictures[0].src"
                            :srcset="currentVersion.pictures[0].xsSrcSet"
                            class="accessory-card-picture-img"
                        >
                    </div>
                    <div class="accessory-card-name col-12">
                        <div class="lead mt-2 mb-1" data-writefontsize="">
                            <strong>{{ accessoryTitle }}</strong>
                        </div>
                    </div>

                    <div class="accessory-card-versions col-12 pb-2">
                        <div v-if="colors.length > 1 && !isAdded">
                            <ob1-pastilles-de-couleurs
                                :id="id + '-colors'"
                                :colors="colors"
                                :is-mini="true"
                            />
                        </div>
                    </div>

                    <div class="accessory-card-price col-12">
                        <ob1-prix-terminal
                            :multiple-price="accessory.hasMultiplePrice && !isAdded"
                            :total-price-with-promo="priceWithPromo"
                            :total-price-without-promo="priceWithoutDiscount"
                        />
                    </div>
                    <div class="accessory-card-advantage col-12 p-0">
                        <advantage-bloc
                            :advantage-messages="advantageMessages"
                            :discount="currentVersion.promoData ? currentVersion.promoData.amountInCents: null"
                            :odr="currentVersion.odrData ? currentVersion.odrData.amountInCents: null"
                        />
                    </div>
                    <div class="accessory-card-das col-12">
                        <das-bundle-accessories
                            v-if="accessory.das"
                            class="mb-1"
                            :head="accessory.das.head"
                            :limbs="accessory.das.member"
                            :prefix="dasDto"
                            :trunk="accessory.das.trunk"
                        />
                    </div>
                    <div class="accessory-card-cta col-12">
                        <div class="d-flex justify-content-center">
                            <div v-if="isLoading">
                                <div class="my-2">
                                    <ob1-progress-indicators :size="50" type="undetermined" />
                                </div>
                            </div>
                            <div v-else-if="!isAdded">
                                <ob1-liens
                                    :is-button="true"
                                    :is-mini="false"
                                    :text="openCardButtonLabel"
                                    :with-arrow="true"
                                    :modal-id="popinId"
                                    class="mt-2"
                                    data-bs-toggle="modal"
                                />
                            </div>
                            <div v-else>
                                <ob1-liens-icone
                                    :mini="false"
                                    :prevent-default="true"
                                    :title="deleteButtonLabel"
                                    class="mt-2"
                                    icon="icon-trash"
                                    @click="onRemoveButtonClick()"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </ob1-cards>
        </div>
        <accessory-popin
            :id="popinId"
            :accessory="accessory"
            :display-version-id-seo="currentVersion.idSeo.value"
            :is-added="isAdded"
            :das-dto="dasDto"
            :compact-promo-messages-dto="compactPromoMessagesDto"
            :is-bundle="false"
            @accessory-add="onAccessoryAddButtonClick"
            @accessory-remove="onAccessoryDeleteButtonClick"
        />
    </div>
</template>

<script>
import AdvantageBloc from "../fragments/AdvantageBloc";
import {ColorSorter} from "../mixins/ColorSorter";
import AccessoryPopin from "./AccessoryPopin.vue";
import {AccessoryStatus} from "../accessories/AccessoryCtrl";
import DasBundleAccessories from "./DasAccessories.vue";

export default {
    components: {DasBundleAccessories, AccessoryPopin, AdvantageBloc},
    mixins: [ColorSorter],
    props: {
        accessory: {
            type: Object,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        dasDto: {
            type: Object,
            required: true
        },
        openCardButtonLabel: {
            type: String,
            required: true
        },
        advantageMessages: {
            type: Object,
            required: true
        },
        accessoryCtrl: {
            type: Object,
            required: true
        },
        compactPromoMessagesDto: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            state: "loaded",
            //version mise au panier
            selectedVersion: this.accessory.versions.find(version => version.selected)

        }
    },
    computed: {
        // version affichée dans la card
        currentVersion(){
            if (this.selectedVersion) return this.selectedVersion
            else return this.accessory.defaultVersion
        },
        isAdded(){
          return this.selectedVersion != null
        },
        popinId() {
            return `popin-${this.id}`;
        },
        isLoading() {
            return this.state === "loading";
        },
        priceWithoutDiscount() {
            if (this.currentVersion.promoData) {
                return this.currentVersion.priceInCents / 100;
            } else {
                return null;
            }
        },
        priceWithPromo() {
            return this.currentVersion.discountedPriceInCents / 100;
        },
        deleteButtonLabel() {
            return 'Supprimer du panier'
        },
        accessoryTitle() {
            if (this.accessory.versions.length > 1) {
                return this.selectedVersion ? this.selectedVersion.name : this.accessory.name
            } else {
                return this.accessory.name
            }
        }
    },
    methods: {
        onRemoveButtonClick() {
            this.onAccessoryDeleteButtonClick()
            event.stopPropagation();// pour ne pas propager le clic d'ouverture de la popin
        },
        onCardClick() {
            if (!this.isLoading) {//on désactive le clic pour éviter des ajouts successifs
                // On rattache la popin directement à l'élément principal de la page,
                // sinon peut poser des soucis de positionnement (quand utilisée avec le swiper entre autre)
                // Cela permet d'appliquer le style ob1-sosh le cas échéant
                $('#' + this.popinId).appendTo("[role='main']").modal("show");
            }
        },
        colors: function () {
            const colors = [];
            for (const color of this.accessory.colors) {
                colors.push(
                        {
                            colorName: color.colorName,
                            code: color.code,
                            inputName: color.inputName,
                        });
            }
            return this.sortColors(colors);
        },
        // Ajout ou remplacement, car il n'est possible de commander en même temps plusieurs déclinaisons d'un même accessoire.
        // Si le client choisi une nouvelle déclinaison, elle remplace la précédente sélectionnée.
        // idSeo : id seo de la déclinaison à ajouter
        onAccessoryAddButtonClick(idSeo) {
            if (this.selectedVersion) {
                // On a besoin de l'accessoire déjà sélectionné pour le remplacer :
                // on le supprime d'abord, puis on ajoute le nouveau
                this.replaceAccessory(idSeo, this.selectedVersion.idSeo.value);
            } else {
                this.addAccessory(idSeo);
            }
        },
        //Une suppression simple sans remplacement
        onAccessoryDeleteButtonClick() {
            this.deleteAccessory(this.selectedVersion.idSeo.value);
        },
        // idSeo : id seo de la déclinaison à mettre à jour
        addAccessory(idSeo) {
            this.state = "loading"
            this.accessoryCtrl.addAccessory(idSeo)
                    .then((result) => {
                        let hasPreviousSelectedVersion = this.selectedVersion != null
                        // On met à jour le nouveau modèle
                        this.setAccessoryAdded(idSeo, true);
                        this.state = "loaded"
                        this.$emit("accessory-updated", result, hasPreviousSelectedVersion ? AccessoryStatus.REPLACE : AccessoryStatus.ADD)
                    })
                    .catch((error) => {
                        if (error?.status === 403) {
                            window.location.href = this.sessionLostUrl
                        } else {
                            this.state = "loaded"
                            this.$emit("accessory-error", error)
                        }
                    });
        },
        deleteAccessory(idSeo) {
            this.state = "loading"
            this.accessoryCtrl.deleteAccessory(idSeo)
                .then((result) => {
                    // On met à jour le nouveau modèle
                    this.setAccessoryAdded(idSeo);
                    this.state = "loaded"
                    this.$emit("accessory-updated", result, AccessoryStatus.DELETE)
                })
                .catch((error) => {
                    if (error?.status === 403) {
                        window.location.href = this.sessionLostUrl
                    } else {
                        this.state = "loaded"
                        this.$emit("accessory-error", error)
                    }
                });
        },
        // idSeo : id seo de la déclinaison à ajouter
        // selectedIdSeo : id seo de la déclinaison déjà sélectionnée (à remplacer)
        replaceAccessory(idSeo, selectedIdSeo) {
            this.state = "loading"
            //On supprime d'abord l'accessoire déjà sélectionné
            this.accessoryCtrl.deleteCrossSellAccessory(selectedIdSeo)
                    .then(() => {
                        this.selectedVersion = null
                        //On ajoute l'accessoire si suppression success
                        this.addAccessory(idSeo)
                    })
                    .catch((_error) => {
                        this.state = "loaded"
                        this.$emit("accessory-error", _error)
                    });
        },
        // idSeo : id seo de la déclinaison à mettre à jour
        // added : précise s'il faut ajouter (true) ou supprimer (false) la déclinaison
        setAccessoryAdded(idSeo, added) {
            if(!added) this.selectedVersion = null;
            else {
                this.accessory.versions.forEach((version) => {
                        if (idSeo === version.idSeo.value) {
                            this.selectedVersion = version
                        }
                });
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import 'ob1_variables';

.accessory-card-promo-tag {
    z-index: 1;
}

.accessory-card-promo-tag strong {
    position: absolute;
}

.accessory-card-picture {
    height: 208px;
    @media(min-width: #{map-get($grid-breakpoints, sm)}) {
        height: 250px;
    }
    @media(min-width: #{map-get($grid-breakpoints, lg)}) {
        height: 260px;
    }
    @media(min-width: #{map-get($grid-breakpoints, xl)}) {
        height: 340px;
    }
    @media(min-width: #{map-get($grid-breakpoints, xl)}) {
        height: 278px;
    }
}

.accessory-card-picture-img {
    margin: auto;
    max-width: 208px;
    max-height: 208px;
    @media(min-width: #{map-get($grid-breakpoints, sm)}) {
        max-width: 250px;
        max-height: 250px;
    }
    @media(min-width: #{map-get($grid-breakpoints, lg)}) {
        max-width: 260px;
        max-height: 260px;
    }
    @media(min-width: #{map-get($grid-breakpoints, xl)}) {
        max-width: 340px;
        max-height: 340px;
    }
    @media(min-width: #{map-get($grid-breakpoints, xl)}) {
        max-width: 278px;
        max-height: 278px;
    }
}

.accessory-card-discount {
    .additional-message {
        margin-left: -15px;
        margin-right: -15px;
    }
}

.accessory-card-odr {
    .additional-message {
        margin-left: -15px;
        margin-right: -15px;
    }
}

</style>
